import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Metodo from "./components/Metodo";
import AllInExperience from "./components/AllInExperience";
import CorsiSingoli from "./components/CorsiSingoli";
import Coaching from "./components/Coaching";
import Laboratori from "./components/Laboratori";
import Formatore from "./components/Formatore";
import Location from "./components/Location";
import Bonus from "./components/Bonus";
import PrezzoCTA from "./components/PrezzoCTA";
import Garanzia from "./components/Garanzia";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import CookieBanner from "./components/CookieBanner";
import ToolsMarquee from "./components/ToolsMarquee";
import BookingModal from "./components/BookingModal";
import CoursePage from "./components/CoursePage";
import UpsellPage from "./components/UpsellPage";
import CheckoutSuccessPage from "./components/CheckoutSuccessPage";
import CheckoutCancelPage from "./components/CheckoutCancelPage";
import CheckoutModal from "./components/CheckoutModal";
import EmbeddedCheckoutPage from "./components/EmbeddedCheckoutPage";
import PrivacyPolicyPage from "./components/legal/PrivacyPolicyPage";
import CookiePolicyPage from "./components/legal/CookiePolicyPage";
import TerminiCondizioniPage from "./components/legal/TerminiCondizioniPage";
import AdminDashboard from "./components/AdminDashboard";
import QuizPage from "./components/QuizPage";
import QuizBookingPage from "./components/QuizBookingPage";
import SocialProofToast from "./components/SocialProofToast";
import LandingPage from "./components/LandingPage";
import Seo from "./components/Seo";
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage, ActivatePage } from "./components/AuthPages";
import StudentArea from "./components/StudentArea";

function ScrollToHashElement() {
  const location = useLocation();
  useEffect(() => {
    const { hash } = location;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, [location]);
  return null;
}

/** SPA route-change tracker: fires GA4 page_view + Meta PageView on every route change.
 *  The initial page load is already tracked by the base pixel/gtag config in index.html. */
function PageViewTracker() {
  const location = useLocation();
  const firstRender = React.useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    (async () => {
      try {
        const { trackPageView } = await import("./lib/analytics");
        trackPageView(location.pathname + location.search);
      } catch (_) { /* never break routing on analytics failure */ }
    })();
  }, [location.pathname, location.search]);
  return null;
}

const Home = ({ onOpenBooking, onOpenCheckout }) => {
  return (
    <div className="App grain">
      <Seo
        title="MyDigitalAction Experience — Formazione digitale in presenza a Pisa"
        description="5 percorsi di formazione professionale in presenza a Pisa: comunicazione digitale, social media marketing, Meta Ads, customer loyalty e Agenti AI. Garanzia soddisfatti o rimborsati."
        path="/"
      />
      <Navbar onOpenBooking={onOpenBooking} />
      <Hero onOpenBooking={onOpenBooking} />
      <ToolsMarquee />
      <Metodo />
      <AllInExperience onOpenCheckout={onOpenCheckout} />
      <CorsiSingoli onOpenCheckout={onOpenCheckout} />
      <Coaching />
      <Laboratori />
      <Formatore />
      <Location />
      <Bonus />
      <PrezzoCTA onOpenBooking={onOpenBooking} onOpenCheckout={onOpenCheckout} />
      <Garanzia />
      <Testimonials />
      <FAQ onOpenBooking={onOpenBooking} />
      <Footer />
      <WhatsAppFloat />
      <CookieBanner />
    </div>
  );
};

function AppShell() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [checkoutState, setCheckoutState] = useState({ open: false, productId: null, productName: null, productPrice: null });

  const openBooking = () => setBookingOpen(true);
  const closeBooking = () => setBookingOpen(false);

  const openCheckout = (productId, productName, productPrice) => {
    setCheckoutState({ open: true, productId, productName, productPrice });
  };
  const closeCheckout = () => setCheckoutState({ open: false, productId: null, productName: null, productPrice: null });

  return (
    <>
      <ScrollToHashElement />
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<Home onOpenBooking={openBooking} onOpenCheckout={openCheckout} />} />
        <Route path="/corso/:slug" element={<CoursePage onOpenBooking={openBooking} onOpenCheckout={openCheckout} />} />
        <Route path="/corso/:slug/upsell" element={<UpsellPage onOpenBooking={openBooking} onOpenCheckout={openCheckout} />} />
        <Route path="/checkout/pagamento" element={<EmbeddedCheckoutPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage onOpenBooking={openBooking} />} />
        <Route path="/checkout/cancel" element={<CheckoutCancelPage onOpenBooking={openBooking} />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/termini-condizioni" element={<TerminiCondizioniPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/quiz" element={<QuizPage onOpenBooking={openBooking} />} />
        <Route path="/quiz/prenota-call" element={<QuizBookingPage onOpenBooking={openBooking} />} />
        <Route path="/landing-corso-cqo" element={<LandingPage slugParam="cqo" onOpenBooking={openBooking} />} />
        <Route path="/landing-corso-smm" element={<LandingPage slugParam="smm" onOpenBooking={openBooking} />} />
        <Route path="/landing-corso-fba" element={<LandingPage slugParam="fba" onOpenBooking={openBooking} />} />
        <Route path="/landing-corso-cl" element={<LandingPage slugParam="cl" onOpenBooking={openBooking} />} />
        <Route path="/landing-corso-ai" element={<LandingPage slugParam="ai" onOpenBooking={openBooking} />} />
        <Route path="/area-studente" element={<StudentArea onOpenBooking={openBooking} />} />
        <Route path="/area-studente/login" element={<LoginPage />} />
        <Route path="/area-studente/registrati" element={<RegisterPage />} />
        <Route path="/area-studente/password-dimenticata" element={<ForgotPasswordPage />} />
        <Route path="/area-studente/reset-password" element={<ResetPasswordPage />} />
        <Route path="/area-studente/attiva" element={<ActivatePage />} />
      </Routes>
      <BookingModal open={bookingOpen} onClose={closeBooking} />
      <CheckoutModal
        open={checkoutState.open}
        onClose={closeCheckout}
        productId={checkoutState.productId}
        productName={checkoutState.productName}
        productPrice={checkoutState.productPrice}
      />
      <SocialProofToast />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
